'use strict';

var _regeneratorRuntime = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _slicedToArray = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _awaitAsyncGenerator = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var CID = require('cids');

var toCamel = require('./lib/object-to-camel');

var configure = require('./lib/configure');

var multipartRequest = require('./lib/multipart-request');

var toUrlSearchParams = require('./lib/to-url-search-params');

var abortSignal = require('./lib/abort-signal');

var _require = require('native-abort-controller'),
    AbortController = _require.AbortController;
/**
 * @typedef {import('ipfs-utils/src/types').ProgressFn} IPFSUtilsHttpUploadProgressFn
 * @typedef {import('ipfs-core-types/src/root').AddProgressFn} IPFSCoreAddProgressFn
 * @typedef {import('./types').HTTPClientExtraOptions} HTTPClientExtraOptions
 * @typedef {import('ipfs-core-types/src/root').API<HTTPClientExtraOptions>} RootAPI
 * @typedef {import('ipfs-core-types/src/root').AddResult} AddResult
 */


module.exports = configure(function (api) {
  /**
   * @type {RootAPI["addAll"]}
   */
  function addAll(_x) {
    return _addAll.apply(this, arguments);
  }

  function _addAll() {
    _addAll = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
      var options,
          controller,
          signal,
          _yield$_awaitAsyncGen,
          headers,
          body,
          total,
          parts,
          _ref,
          _ref2,
          progressFn,
          onUploadProgress,
          res,
          _iteratorAbruptCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          file,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              // allow aborting requests on body errors
              controller = new AbortController();
              signal = abortSignal(controller.signal, options.signal);
              _context.next = 5;
              return _awaitAsyncGenerator(multipartRequest(source, controller, options.headers));

            case 5:
              _yield$_awaitAsyncGen = _context.sent;
              headers = _yield$_awaitAsyncGen.headers;
              body = _yield$_awaitAsyncGen.body;
              total = _yield$_awaitAsyncGen.total;
              parts = _yield$_awaitAsyncGen.parts;
              // In browser response body only starts streaming once upload is
              // complete, at which point all the progress updates are invalid. If
              // length of the content is computable we can interpret progress from
              // `{ total, loaded}` passed to `onUploadProgress` and `multipart.total`
              // in which case we disable progress updates to be written out.
              _ref = typeof options.progress === 'function' // @ts-ignore tsc picks up the node codepath
              ? createProgressHandler(total, parts, options.progress) : [undefined, undefined], _ref2 = _slicedToArray(_ref, 2), progressFn = _ref2[0], onUploadProgress = _ref2[1];
              _context.next = 13;
              return _awaitAsyncGenerator(api.post('add', {
                searchParams: toUrlSearchParams(_objectSpread(_objectSpread({
                  'stream-channels': true
                }, options), {}, {
                  progress: Boolean(progressFn)
                })),
                timeout: options.timeout,
                onUploadProgress: onUploadProgress,
                signal: signal,
                headers: headers,
                body: body
              }));

            case 13:
              res = _context.sent;
              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context.prev = 16;
              _iterator = _asyncIterator(res.ndjson());

            case 18:
              _context.next = 20;
              return _awaitAsyncGenerator(_iterator.next());

            case 20:
              if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                _context.next = 32;
                break;
              }

              file = _step.value;
              file = toCamel(file);

              if (!(file.hash !== undefined)) {
                _context.next = 28;
                break;
              }

              _context.next = 26;
              return toCoreInterface(file);

            case 26:
              _context.next = 29;
              break;

            case 28:
              if (progressFn) {
                progressFn(file.bytes || 0, file.name);
              }

            case 29:
              _iteratorAbruptCompletion = false;
              _context.next = 18;
              break;

            case 32:
              _context.next = 38;
              break;

            case 34:
              _context.prev = 34;
              _context.t0 = _context["catch"](16);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 38:
              _context.prev = 38;
              _context.prev = 39;

              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context.next = 43;
                break;
              }

              _context.next = 43;
              return _awaitAsyncGenerator(_iterator.return());

            case 43:
              _context.prev = 43;

              if (!_didIteratorError) {
                _context.next = 46;
                break;
              }

              throw _iteratorError;

            case 46:
              return _context.finish(43);

            case 47:
              return _context.finish(38);

            case 48:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[16, 34, 38, 48], [39,, 43, 47]]);
    }));
    return _addAll.apply(this, arguments);
  }

  return addAll;
});
/**
 * Returns simple progress callback when content length isn't computable or a
 * progress event handler that calculates progress from upload progress events.
 *
 * @param {number} total
 * @param {{name:string, start:number, end:number}[]|null} parts
 * @param {IPFSCoreAddProgressFn} progress
 * @returns {[IPFSCoreAddProgressFn|undefined, IPFSUtilsHttpUploadProgressFn|undefined]}
 */

var createProgressHandler = function createProgressHandler(total, parts, progress) {
  return parts ? [undefined, createOnUploadProgress(total, parts, progress)] : [progress, undefined];
};
/**
 * Creates a progress handler that interpolates progress from upload progress
 * events and total size of the content that is added.
 *
 * @param {number} size - actual content size
 * @param {{name:string, start:number, end:number}[]} parts
 * @param {IPFSCoreAddProgressFn} progress
 * @returns {IPFSUtilsHttpUploadProgressFn}
 */


var createOnUploadProgress = function createOnUploadProgress(size, parts, progress) {
  var index = 0;
  var count = parts.length;
  return function (_ref3) {
    var loaded = _ref3.loaded,
        total = _ref3.total;
    // Derive position from the current progress.
    var position = Math.floor(loaded / total * size);

    while (index < count) {
      var _parts$index = parts[index],
          start = _parts$index.start,
          end = _parts$index.end,
          name = _parts$index.name; // If within current part range report progress and break the loop

      if (position < end) {
        progress(position - start, name);
        break; // If passed current part range report final byte for the chunk and
        // move to next one.
      } else {
        progress(end - start, name);
        index += 1;
      }
    }
  };
};
/**
 * @param {any} input
 */


function toCoreInterface(_ref4) {
  var name = _ref4.name,
      hash = _ref4.hash,
      size = _ref4.size,
      mode = _ref4.mode,
      mtime = _ref4.mtime,
      mtimeNsecs = _ref4.mtimeNsecs;

  /** @type {AddResult} */
  var output = {
    path: name,
    cid: new CID(hash),
    size: parseInt(size)
  };

  if (mode != null) {
    output.mode = parseInt(mode, 8);
  }

  if (mtime != null) {
    output.mtime = {
      secs: mtime,
      nsecs: mtimeNsecs || 0
    };
  }

  return output;
}